import { useCallback } from 'react';
import { IconProviderValue, SideBarTabIcon } from './editor-side-bar/SideBarTabIcon';
import { useTemplateEditorDispatch, useTemplateEditorState } from '../context/UseTemplateEditorContext';

export const TemplateSidebarTab = ({
  tabName,
  tooltipHeading,
  tooltipDescription,
  icon,
  dataTestId,
  iconProvider,
  active,
  onClick,
  ...props
}: {
  tooltipHeading: string;
  icon: string;
  dataTestId: string;
  tabName?: string;
  tooltipDescription?: string;
  iconProvider?: IconProviderValue;
  active?: boolean;
  onClick?: () => void;
} & IntrinsicProps) => {
  const { activeLeftTab, activeRightTab } = useTemplateEditorState();

  const dispatch = useTemplateEditorDispatch();

  const isActive = active || activeLeftTab === tabName || activeRightTab === tabName;

  const onLeftTabClick = useCallback(() => {
    dispatch({
      type: 'SET_LEFT_WINDOW',
      payload: {
        tab: tabName,
      },
    });
  }, [dispatch, tabName]);

  return (
    <SideBarTabIcon
      icon={icon}
      active={isActive}
      onClick={onClick ?? onLeftTabClick}
      tooltipHeading={tooltipHeading}
      tooltipDescription={tooltipDescription}
      data-testid={dataTestId}
      iconProvider={iconProvider}
      {...props}
    />
  );
};
